import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdService } from 'src/app/services/ad.service';
import { AdsType } from '../interfaces/ads';

@Component({
	selector: 'app-settings-ads',
	templateUrl: './settings-ads.component.html',
	styleUrls: ['./settings-ads.component.scss']
})
export class SettingsAdsComponent implements OnInit {
	public formAds!: FormGroup
	public showSpinner: boolean = false
	public dataAvailable: boolean = false
	ad: AdsType = {}
	ads: Array<AdsType> = []
	constructor(
		private formBuilder: FormBuilder,
		private adService: AdService
	) {

	}

	ngOnInit(): void {
		this.getAds()
	}

	createForm() {
		this.formAds = this.formBuilder.group({
			id: [this.ad.id ? this.ad.id : null],
			nome: [this.ad.nome, Validators.required],
			tipo: ["youtube", Validators.required],
			url: [this.ad.url, Validators.required],
			status: [this.ad.status, Validators.required],
		})
	}

	submitForm() {
		this.showSpinner = true
		if(this.formAds.valid){
			if(this.formAds.value.id){
				this.adService.updateAd(this.formAds.value)
			}else{
				this.adService.insertAd(this.formAds.value)
			}
		}
		setTimeout(() => {
			this.showSpinner = false
		}, 1000);
	}

	getAds() {
		this.adService.getAds().forEach(
			(element: any) => {
				if (element && element.length > 0) {
					this.ad = element[0]
				}
				this.createForm()
				this.dataAvailable = true
			}
		)
	}
}
